// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: true,
    apiUrl: 'https://app.lybox.fr/',
    // apiUrl: 'http://localhost:8081/',

    google_client_id: '450017807989-tt3rqjludmg614uar7mirve5j07eiauh.apps.googleusercontent.com',
    facebook_client_id: '352603785769360',
    impotUrl: 'https://dfvy5tfns6.execute-api.eu-west-3.amazonaws.com/default/impot',
    empruntUrl: 'https://89pbt8we7d.execute-api.eu-west-3.amazonaws.com/default/simu_emprunt',
    stripeKey: 'pk_live_51HUeKODeg55eSBYjXHNap9hO3kctmHWI1cp19TjCgHFYdxxuEP4VhRcTMrpT9D7kun95oRiP6MpDyqbE6S103YwC000HF5Mnpm',

    // google_client_id: '450017807989-tt3rqjludmg614uar7mirve5j07eiauh.apps.googleusercontent.com',
    // facebook_client_id: '352603785769360',cla
    // impotUrl: 'https://a1q5mewsk3.execute-api.eu-west-3.amazonaws.com/default/impot-dev',
    // stripeKey: 'pk_test_51HUeKODeg55eSBYjVJaj9J50DDskeYYyOwMyumYDaQQnG02eFAMx3HutZQWmwwGuKy5jaLL2GQf3RqUNwC8UrDM600NOY6w7nG',
    // impotUrl: 'https://dfvy5tfns6.execute-api.eu-west-3.amazonaws.com/default/impot',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
